import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import { renderInput, renderTextArea, renderDatePicker, renderMultiselect, renderCheckbox } from "../common/renderinput";


class LienForm extends Component {
    render() {
        return (
            <>
                <div className="form-row col-12 pl-0 mt-2" >
                <div className="col-5" >
                        <Field name="Plaintiff"  component={renderInput} label="Plaintiff/Debtor" isLabel={true}/>
                </div>                
                <div className="col-5" >
                        <Field name="LienType"  component={renderInput} label="Lien Type" isLabel={true}/>
                </div>
                <div className="col-2" >
                        <Field name="UCC" type="checkbox" component={renderCheckbox} label="UCC" isLabel={true} />
                    </div>
                </div>
                <div className="form-row col-12 pl-0 mt-2" >
                <div className="col-5" >
                        <Field name="Defendant"  component={renderInput} label="Plaintiff/Debtor" isLabel={true}/>
                </div>                
                <div className="col-2" >
                        <Field name="DOB"  component={renderInput} label="DOB" isLabel={true}/>
                </div>
                <div className="col-2" >
                        <Field name="SSN"  component={renderInput} label="SSN" isLabel={true} />
                    </div>
                </div>

                    <div className="form-row col-12 pl-0 mt-2" >
                    <div className="col-4" >
                            <Field name="Docket" component={renderInput} label="Docket" isLabel={true} />
                        </div>
                        <div className="col-2" >
                            <Field name="LienDate" component={renderDatePicker} label="Lien Date" isLabel={true} />
                        </div>

                        <div className="col-2" >
                            <Field name="RecordedDate" component={renderDatePicker} label="Recorded Date" isLabel={true} />
                        </div>

                        <div className="col-2" >
                            <Field name="LienAmount" component={renderInput} label="Lien Amount" isLabel={true} />
                        </div>
                        <div className="col-1" >
                            <Field name="VolInst" component={renderInput} label="Vol/Inst" isLabel={true} />
                        </div>
                        <div className="col-1" >
                            <Field name="Page" component={renderInput} label="Page" isLabel={true} />
                        </div>

                    </div>
                    <div className="form-row col-12 pl-0 " >
                    <div className="col-12" >
                        <Field name="Comments" component={renderTextArea} label="Comments" isLabel={true} />
                    </div>
                </div>
            </>
        );
    }
}
export default LienForm;